import React, { Fragment } from 'react';
import EngineScoringListBrowser from './EngineScoringListBrowser';
import PropTypes from 'prop-types';
import HeaderPortal from '../../../../components/layout/HeaderPortal';
import HeaderLinks from '../list/header/HeaderLinks';
import Portal from 'utils/portal/Portal';
import { withAreaGetter } from 'providers/AreasConsumers';
import { areas } from 'constants/areas';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_SCORING } from 'constants/rightsCodes';

const Route = ({ getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();

  const onAdd = () => {
    historyContext.push(`/scoringEngine/new`);
  };

  return (
    <Fragment>
      <HeaderPortal />
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <HeaderLinks onAdd={onAdd}></HeaderLinks>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_SCORING}>
        <EngineScoringListBrowser />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
